import { Routes } from '@angular/router';
import { authGuard, sesionGuard } from './modules/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./modules/inicio/inicio.component').then((m) => m.InicioComponent),
      },
    ],
  },
  // Unilogin manda aquí al trabajador (/enc/0/0/N35GR3). Fase 1: datos de prueba.
  // Cuando exista GEM en car.modulo y la API, se valida también el módulo.
  {
    path: 'enc/:clave/:subclave/:encuesta',
    canActivate: [sesionGuard],
    loadComponent: () =>
      import('./modules/encuesta/encuesta.component').then((m) => m.EncuestaComponent),
  },
  { path: '**', redirectTo: '' },
];
